import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';
import { API_URL } from '../config';

class WBOrdersStore {
    orders = [];
    loading = false;
    error = null;

    constructor() {
        makeAutoObservable(this);
    }

    fetchOrders = async () => {
        try {
            this.loading = true;
            this.error = null;
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/v1/orders/WB/get_orders`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            runInAction(() => {
                this.orders = response.data.data?.orders || [];
                this.loading = false;
            });
        } catch (error) {
            runInAction(() => {
                this.error = error.response?.data?.message || error.message || 'Ошибка при загрузке заказов WB';
                this.loading = false;
                this.orders = [];
            });
        }
    };

    printPostingLabel = async (postingNumber) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${API_URL}/v1/orders/WB/print_label/${postingNumber}`,
                {},
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    responseType: 'blob'
                }
            );

            // Создаем ссылку для скачивания файла
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `wb_label_${postingNumber}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            return { message: 'Этикетка успешно загружена' };
        } catch (error) {
            throw new Error(error.response?.data?.message || error.message || 'Ошибка при загрузке этикетки');
        }
    };
}

const wbOrdersStore = new WBOrdersStore();
export default wbOrdersStore; 